import React from 'react';
// TODO: refactor this
// eslint-disable-next-line
import { useAsObservableSource } from 'mobx-react-lite';
import { observer } from 'src/utils/mobx-react';
import { EventGroupHeader6Pack } from 'src/domains/sportsbook/webview/components/eventsList/eventGroupHeader6Pack/EventGroupHeader6Pack';
import { getMarketNameNHL } from 'src/domains/sportsbook/webview/components/eventsList/eventRowNHL/EventRowNHL.state';
import { useCommon } from 'src/domains/common/Common';
import { LanguagesState } from 'src/domains/layouts/state/languagesState/LanguagesState';

interface EventGroupHeaderPropsType {
    label: string;
    open: boolean;
    onToggle: () => void;
    dataTest?: string;
}

export const EventGroupHeaderNHL = observer('EventGroupHeaderNHL', (propsIn: EventGroupHeaderPropsType) => {
    const common = useCommon();
    const languagesState = LanguagesState.get(common);
    const props = useAsObservableSource(propsIn);
    const { dataTest, label, open, onToggle } = props;

    return (
        <EventGroupHeader6Pack
            dataTest={dataTest}
            label={label}
            marketNames={getMarketNameNHL(languagesState.getTranslation)}
            onToggle={onToggle}
            open={open}
        />
    );
});
